import { addToTray, removeFromTray, snapshot, useCompareTray } from "@/lib/compareTray";
import { Check, Plus } from "lucide-react";

export function CompareButton({ listing, variant = "card" }) {
  const items = useCompareTray();
  const inTray = items.some((c) => c.id === listing.id);
  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inTray) removeFromTray(listing.id); else addToTray(snapshot(listing));
  };
  const base = variant === "card"
    ? "h-8 px-3 rounded-full text-xs font-semibold backdrop-blur-md border transition-colors"
    : "w-full h-11 rounded-full text-sm font-semibold border transition-colors mt-3";
  const tone = inTray ? "bg-teal text-white border-teal" : variant === "card" ? "bg-white/85 text-navy border-white hover:bg-white" : "bg-white text-navy border-navy/15 hover:border-teal";
  return (
    <button type="button" onClick={toggle} className={`${base} ${tone} inline-flex items-center justify-center gap-1`} data-testid={`compare-btn-${listing.id}`} aria-pressed={inTray}>
      {inTray ? <><Check className="w-3.5 h-3.5" />In compare</> : <><Plus className="w-3.5 h-3.5" />Compare</>}
    </button>
  );
}
